export const transparent = 'transparent';
export const black = '#000';
export const hoverBackground = 'rgba(48, 48, 48, 0.8)';
export const brightBlack = '#43494F';
export const blackText = '#666';
export const lightGray = '#f8f8f8';
export const grey = '#ccc';
export const red = '#ff0000';

export const Color = {
  green: '#52c41a',
  lightGreen: '#6bd098',
  blue: '#8fc9fb',
  purple: '#d897eb',
  red: '#d7466e',
  yellow: '#f8c82e',
  peach: '#f797d6',
  borderBase: '#e5e5e5',
  borderSplit: '#f4f4f4',
  grass: '#d6fbb5',
  sky: '#c1e0fc',
  orange: '#e8874e',
  white: '#fff'
};
